import React from 'react';
import { Form } from 'react-final-form';
import { useHistory, useLocation } from 'react-router';

import { MDText } from 'i18n-react';

import { Button } from '@motorway/mw-highway-code';
import { BUTTON_TYPE, INFOBOX_VARIANT, SIZE, VARIANT } from '@motorway/mw-highway-code/enums';
import { toast } from '@motorway/mw-highway-code/pre-alpha';

import cypressIds from 'CypressId';

import { applyCypressData } from 'Utilities';

import { useMotCheck } from '../../../../Hooks/useMotChecker';
import { isValidVRM, unprettyVRM } from '../../../../Pages/CheckerRouter.utils';
import LocalTexts from '../../../../texts.json';
import { CheckerVRMField } from '../CheckerVRMField/CheckerVRMField';

import { getVrmErrorTexts } from './CheckerForm.helpers';

import styles from './CheckerForm.scss';

const LocalT = new MDText(LocalTexts);

const t = (key: string) => LocalT.translate(key) as string;

export const TEXTS = {
  errorMessage: t('hero.vrmForm.errorMessage'),
  label: t('hero.vrmForm.inputLabel'),
  motCtaLabel: t('hero.vrmForm.motButtonLabel'),
  taxCtaLabel: t('hero.vrmForm.taxButtonLabel'),
};

export const CheckerForm = ({ isMotCheck }:{isMotCheck: boolean}) => {
  const history = useHistory();
  const { pathname } = useLocation();

  const { motCtaLabel, taxCtaLabel, ...inputTexts } = TEXTS;

  const ctaLabel = isMotCheck ? motCtaLabel : taxCtaLabel;

  const onError = (status: number, vrm: string) => {
    const { detail, title } = getVrmErrorTexts(status, vrm);

    toast({
      content: detail,
      heading: title,
      important: true,
      variant: INFOBOX_VARIANT.ERROR,
    });
  };

  const onSuccess = () => {
    history.push(`${pathname}/results`);
  };

  const { motCheckAction } = useMotCheck({ onError, onSuccess });

  const formOnSubmit = async ({ motCheckVrm: vrm }: Record<string, string>) => {
    const isVRMValid = vrm && isValidVRM(vrm);
    const trimVRM = isVRMValid && unprettyVRM(vrm);

    if (!isVRMValid) {
      return;
    }

    await motCheckAction(trimVRM);
  };

  return (
    <div className={styles.checkerForm}>
      <Form
        onSubmit={formOnSubmit}
        render={({ handleSubmit, submitting }) => (
          <form
            onSubmit={handleSubmit}
          >
            <CheckerVRMField
              texts={{ ...inputTexts }}
            />

            <div className={ styles.ctaWrapper }>
              <Button
                {...applyCypressData(cypressIds.buttons.checkMot)}
                data-thc-button
                fullWidth
                icon={'chevron'}
                label={ctaLabel}
                loading={submitting}
                size={SIZE.LARGE}
                type={BUTTON_TYPE.SUBMIT}
                variant={VARIANT.PRIMARY}
              />
            </div>
          </form>
        )}
      />
    </div>
  );
};
